import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { App } from "antd";
import { TIENDA_PAQUETES, LOADING_TIENDA_PAQUETE } from "../store/selectors";
import {
  setLoading,
  setTiendaPaquetes,
  deleteTiendaPaquete as deleteTiendaPaqueteAction,
} from "../store/slices/tiendaPaquete";
import {
  getTiendaPaquetes,
  getTiendaPaquete as getTiendaPaqueteService,
  deleteTiendaPaquete as deleteTiendaPaqueteService,
} from "../services/tienda-paquetes/tienda-paquete.service";

export const useTiendaPaquetes = (schoolId?: number) => {
  // From App.useApp(): the static notification does not render under React 19.
  const { notification } = App.useApp();
  const dispatch = useDispatch();
  const tiendaPaquetes = useSelector(TIENDA_PAQUETES);
  const loading = useSelector(LOADING_TIENDA_PAQUETE);

  const fetchInfo = async () => {
    dispatch(setLoading(true));
    try {
      const data = await getTiendaPaquetes(schoolId);
      dispatch(setTiendaPaquetes(data));
    } catch (error: any) {
      dispatch(setLoading(false));
      notification.error({
        message: "Error",
        description: "No se pudieron cargar los paquetes.",
        placement: "top",
        duration: 3,
      });
    }
  };

  const getTiendaPaqueteById = async (id: number) => {
    try {
      return await getTiendaPaqueteService(id);
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: "No se pudo cargar el paquete.",
        placement: "top",
        duration: 3,
      });
      return null;
    }
  };

  const deleteTiendaPaquete = async (id: number): Promise<boolean> => {
    dispatch(setLoading(true));
    try {
      const ok = await deleteTiendaPaqueteService(id);
      dispatch(setLoading(false));
      if (ok) {
        dispatch(deleteTiendaPaqueteAction(id));
        notification.success({
          message: "Éxito",
          description: "El paquete fue eliminado exitosamente.",
          placement: "top",
          duration: 3,
        });
        return true;
      }
      notification.error({
        message: "Error",
        description: "No se pudo eliminar el paquete.",
        placement: "top",
        duration: 3,
      });
      return false;
    } catch (error: any) {
      dispatch(setLoading(false));
      notification.error({
        message: "Error",
        description:
          error?.response?.data?.message || "No se pudo eliminar el paquete.",
        placement: "top",
        duration: 3,
      });
      return false;
    }
  };

  useEffect(() => {
    fetchInfo();
  }, [schoolId]);

  return {
    loading,
    tiendaPaquetes,
    getTiendaPaqueteById,
    deleteTiendaPaquete,
  };
};
